@if ((getSelectedOptions()?.length || 0) === 1) {
  <span [translate]="getSelectedOptions()[0].text"></span>
} @else {
  <span [translate]="label()"></span>
  @if ((getSelectedOptions()?.length || 0) > 1) {
    <span> (+ <span [innerText]="getSelectedOptions()?.length"></span>)</span>
  }
}
